import React from "react";
import { Outlet, NavLink, useNavigate, Navigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import {
  FiGrid,
  FiUsers,
  FiVideo,
  FiBriefcase,
  FiCheckCircle,
  FiBell,
  FiLogOut,
} from "react-icons/fi";

import "./AdminLayout.css";

/* Protect Admin Routes */
export const AdminProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("adminToken");

  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

const AdminLayout = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    navigate("/admin/login");
  };

  return (
    <div className="admin-layout">
      {/* ---------- TOP BAR ---------- */}
      <header className="admin-topbar">
        <div className="d-flex align-items-center gap-3">
          <div className="brand-logo-box">B</div>
          <h5 className="mb-0 fw-bold">BMA Admin</h5>
        </div>

        <div className="topbar-actions">
          {/* Notification */}
          <div className="notification-bell">
            <FiBell />
            <span className="notification-badge">9</span>
          </div>

          {/* Profile Dropdown */}
          <Dropdown align="end">
            <Dropdown.Toggle as="div" className="user-profile">
              <div className="text-end d-none d-md-block">
                <div
                  style={{
                    fontSize: "10px",
                    color: "var(--text-secondary-dark)",
                  }}
                >
                  WELCOME
                </div>
                <div style={{ fontSize: "13px", fontWeight: "bold" }}>
                  ADMIN
                </div>
              </div>

              <div className="avatar-circle">A</div>
            </Dropdown.Toggle>

            <Dropdown.Menu
              variant="dark"
              className="shadow-lg border-0 mt-2 p-2"
              style={{ minWidth: "200px" }}
            >
              <div className="px-3 py-2 border-bottom border-secondary mb-2">
                <small className="text-muted d-block">Logged in as</small>
                <strong>BMA Admin</strong>
              </div>

              <Dropdown.Item
                onClick={handleLogout}
                className="text-danger d-flex align-items-center gap-2 rounded"
              >
                <FiLogOut /> Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </header>

      {/* ---------- BODY ---------- */}
      <div className="admin-body">
        {/* SIDEBAR */}
        <aside className="admin-sidebar">
          <ul className="sidebar-nav">
            <li>
              <NavLink
                to="/admin/dashboard"
                className={({ isActive }) =>
                  `nav-item ${isActive ? "active" : ""}`
                }
              >
                <FiGrid /> Dashboard
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/admin/candidates"
                className={({ isActive }) =>
                  `nav-item ${isActive ? "active" : ""}`
                }
              >
                <FiUsers /> Candidates
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/admin/casting-directors"
                className={({ isActive }) =>
                  `nav-item ${isActive ? "active" : ""}`
                }
              >
                <FiUsers /> Casting Directors
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/admin/directors"
                className={({ isActive }) =>
                  `nav-item ${isActive ? "active" : ""}`
                }
              >
                <FiVideo /> Directors / Producers
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/admin/projects"
                className={({ isActive }) =>
                  `nav-item ${isActive ? "active" : ""}`
                }
              >
                <FiBriefcase /> Projects
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/admin/roles"
                className={({ isActive }) =>
                  `nav-item ${isActive ? "active" : ""}`
                }
              >
                <FiCheckCircle /> Roles
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/admin/lookups"
                className={({ isActive }) =>
                  `nav-item ${isActive ? "active" : ""}`
                }
              >
                <FiCheckCircle /> lookups
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/admin/notification-logs"
                className={({ isActive }) =>
                  `nav-item ${isActive ? "active" : ""}`
                }
              >
                <FiUsers /> Notification Logs
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/admin/notifications"
                className={({ isActive }) =>
                  `nav-item ${isActive ? "active" : ""}`
                }
              >
                <FiBell /> Notifications templates
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/admin/contact-list"
                className={({ isActive }) =>
                  `nav-item ${isActive ? "active" : ""}`
                }
              >
                <FiBell /> Cotact List
              </NavLink>
            </li>
            
            <li>
              <NavLink
                to="/admin/audition-list"
                className={({ isActive }) =>
                  `nav-item ${isActive ? "active" : ""}`
                }
              >
                <FiUsers /> Audition List
              </NavLink>
            </li>
             <li>
              <NavLink
                to="/admin/cost-page"
                className={({ isActive }) =>
                  `nav-item ${isActive ? "active" : ""}`
                }
              >
                <FiUsers /> Cost Pricing List
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/admin/coupon-redeem"
                className={({ isActive }) =>
                  `nav-item ${isActive ? "active" : ""}`
                }
              >
                <FiUsers /> Coupon 
              </NavLink>
            </li>
          </ul>
        </aside>

        {/* MAIN CONTENT */}
        <main className="admin-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;